<style lang="scss">
  .show-more-wrapper {
    display: flex;
    justify-content: center;
    padding-top: 12px;
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";

  export let showingMore;
</script>

<div class="show-more-wrapper">
  <Button kind="tertiary-grey" onclick={() => (showingMore = !showingMore)}>
    {showingMore ? "Show less" : "Show more"}
  </Button>
</div>
